export const questionType = {
  single: { id: 1, name: "Single" },
  multiple: { id: 2, name: "Multiple" },
  correspondence: { id: 3, name: "Correspondence" },
  essay: { id: 4, name: "Essay" },
  open: { id: 5, name: "Open" }
};

export const practicalModules = {
  skills: { id: 1, name: "Practical Skills" },
  experience: { id: 1, name: "Work Experience" }
};

/**
 * Premises a booking can be delivered at, matching the office_types table,
 * and the kinds of booking, matching event_types. Both are seeded data with
 * fixed ids that the booking form has to reason about by identity.
 */
export const OFFICE_TYPE_OFFICE = 1;
export const OFFICE_TYPE_CUSTOMER = 2;
export const OFFICE_TYPE_ONLINE = 3;

export const EVENT_TYPE_COURSE = 1;
export const EVENT_TYPE_AUDIT = 2;
export const EVENT_TYPE_ONLINE_COURSE = 3;
